import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import axios from 'axios';
import ReactDOM from 'react-dom';
import Modal from "react-responsive-modal";
import { Row, Col, TabContent, TabPane,  Card, CardImg, CardTitle} from 'reactstrap';
import Swiper from 'react-id-swiper';
import StarRatingComponent from 'react-star-rating-component';
import * as vars from '../../constants/variables';
import { messages } from '../../constants/messages';
import { messages_ar } from '../../constants/messages_ar';
import { messages_kk } from '../../constants/messages_kk';
import { messages_fr } from '../../constants/messages_fr';
import { messages_sv } from '../../constants/messages_sv';
import { messages_no } from '../../constants/messages_no';
import { messages_vi } from '../../constants/messages_vi';
import { messages_tr } from '../../constants/messages_tr';
import { messages_it } from '../../constants/messages_it';
import { messages_cy } from '../../constants/messages_cy';
import { messages_de } from '../../constants/messages_de';
import { messages_el } from '../../constants/messages_el';
import { messages_cz } from "../../constants/messages_cz";
import { showMessage } from '../../actions/FlashMessageActions';
import { messages_pt } from '../../constants/messages_pt';
import { messages_lt } from '../../constants/messages_lt';
import { getGameDetail, getSimilarGames } from "../../actions/GamesActions";
import { show, hide } from "../../actions/ActivityIndicatorActions";
import { appendUid, validURL } from "../../utils/helper";
import { FormattedMessage } from 'react-intl';
import { config } from '../../constants/domainConfig';
import { isIOS } from 'react-device-detect';
import { sendData } from '../../analytics/sendData';
import {isGamiclub} from './../../constants/isGamiclub';
import { DefaultPlayer as Video } from 'react-html5video';
import 'react-html5video/dist/styles.css';
import { isGameflares, isGamiway } from '../../constants/productCondition';

let kazakhDomain
let lang 
let msg;


class GameDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: '1',
            rating: 0,
            liked:0,
            isFavorite: 0,
            categoryId:0,
            gameId:0,
            openGame: false,
            game: '',
            open: false
        };
        this.toggle = this.toggle.bind(this);
        this._openGame = this._openGame.bind(this);
        this.loadGame = this.loadGame.bind(this);
        this.markFavourite = this.markFavourite.bind(this);
        this.downloadGameApk = this.downloadGameApk.bind(this);
        this.changeDomain = this.changeDomain.bind(this);
        this.applyUpsellingFlow = this.applyUpsellingFlow.bind(this);
        this.translatePlatform =  this.translatePlatform.bind(this);
        this.translateCategory = this.translateCategory.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        sendData(this.state.game.gameTitle, this.state.game.categoryName, this.state.game.gameType, 'viewed', {page: 'game page'});
    }

    componentDidUpdate(prevProps, prevState){
        if (this.state.openGame && prevState.gameId != this.state.gameId){
            sendData(prevState.game.gameTitle, prevState.game.categoryName, prevState.game.gameType, 'finished');
            sendData(this.state.game.gameTitle, this.state.game.categoryName, this.state.game.gameType, 'played');
        } 
        else if (!this.state.openGame && prevState.gameId != this.state.gameId){
            sendData(this.state.game.gameTitle, this.state.game.categoryName, this.state.game.gameType, 'viewed')
        }
        
    }

    componentWillMount() {
        let gameId = this.props.match.params.gameId;
        let uid = this.props.access.uid;
        this.getGameDetail(gameId,uid);
        const searchContainer = document.querySelector("#search-container");

        if(searchContainer != null){
            if (searchContainer.classList.contains('search-toggle')) {
                searchContainer.classList.toggle("search-toggle");
            }
        }
    }

    componentWillUnmount(){
        if(this.state.openGame){
            sendData(this.state.game.gameTitle, this.state.game.categoryName, this.state.game.gameType, 'finished')
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match.params.gameId != nextProps.match.params.gameId) {
            this.getGameDetail(nextProps.match.params.gameId,this.props.access.uid);
        }
    }

    rateGame(){
        let data = {
            uid: this.props.access.uid,
            gameId: this.state.gameId,
            liked: (this.state.liked == 0) ? true : false
        };
        sendData(this.state.game.gameTitle, this.state.game.categoryName, this.state.game.gameType, (data.liked)? 'liked':'unliked');
        axios.post(vars.BASE_URL+'/userLike', data)
            .then((response) => {
                if(response.status){
                    this.setState({
                        liked: (this.state.liked == 0) ? 1 : 0
                    })
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    downloadGameApk(e, href){
        e.preventDefault(); 
        if (this.shouldUpsell(this.state.game.gameId)) this.applyUpsellingFlow();
        else {
            if (isIOS) {
                this.onOpenModal();
            } else {
                this.downloadApk(href);
            }
            return false;
        }   
    }
    changeDomain(){
        kazakhDomain = (config.lang == 'kk') ? true : false;
        lang = config.lang;
        switch (config.lang) {
            case 'ar': msg = messages_ar;
                break;
            case 'kk': msg = messages_kk;
                break;
            case 'fr': msg = messages_fr;
                break;
            case 'sv': msg = messages_sv;
                break;
            case 'no': msg = messages_no;
                break;
            case 'vi': msg = messages_vi;
                break;
            case 'tr': msg = messages_tr;
                break;
            case 'it': msg = messages_it;
                break;
            case 'cy': msg = messages_cy;
                break;
            case 'de': msg = messages_de;
                break;
            case 'el': msg = messages_el;
                break;
            case 'cs': msg = messages_cz;
                break;
            case 'pt': msg = messages_pt;
                break;
            case 'lt': msg = messages_lt;
                break;    
            default: msg = messages;
                break;
        }
    }
    downloadApk(href) {
        if(validURL(href)){
            window.location.href = href;
        }
        else{
            window.location.href = vars.cdnUrl + href;
        }
         sendData(this.state.game.gameTitle, this.state.game.categoryName, this.state.game.gameType, 'downloaded');
        if ((config.subDomain == 'idsale' || config.subDomain==='gmn') && (this.props.access.subscriptionData.allowedApps.indexOf(this.state.game.gameId) >=0)){
             this.props.history.push(`/welcome?uid=${this.props.access.uid}`);
         }
    }

    onOpenModal(){
        this.setState({ open: true });
    };

    onCloseModal(){
        this.setState({ open: false });
    };

    markFavourite(gameData) {
        let data = {
            uid: this.props.access.uid,
            gameId: gameData.game.gameId,
            isFavorite: gameData.isFavorite
        };
        if(data.isFavorite){
            this.props.showMessage({
                message: msg.addToFavorites,
                type: true
            });
        }
        else{
            this.props.showMessage({
                message: msg.removeFromFavorites,
                type: false
            });
        }
        sendData(gameData.game.gameTitle, gameData.game.categoryName, gameData.game.gameType, data.isFavorite ? 'favorite-added' : 'favorite-removed');
        axios.post(vars.BASE_URL+'/favorite', data)
            .then((response) => {
                if (response.status) {
                    this.setState({
                        isFavorite: (this.state.isFavorite) ? 0 : 1
                    });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    translatePlatform(plt) {
        var platforms = ["PC, Tablet & Mobile", "Mobile & Tablet", "PC, Mobile & Tablets"]
        if(plt === 'Mobile and Tablet') plt = 'Mobile & Tablet'
        let index = platforms.indexOf(plt)
        if(config.lang == 'cy'){
            platforms = ["Десктоп,таблет & мобилни телефон", "мобилни телефон & таблет", "Десктоп,таблет & мобилни телефон"]
        }
        if(config.lang == 'de'){
            platforms = ["PC, Tablet & Mobilgeräte", "Mobilgeräte & Tablets", "PC, Tablet & Mobilgeräte"]
        }
        if(config.lang == 'fr'){
            platforms = ["PC, tablette et mobile", "Mobile et Tablette", "PC, tablette et mobile"]
        }
        if(config.lang == 'ro'){
            platforms = ["PC, tabletă și mobil", " mobil și tabletă", "PC, mobil și tabletă"]
        }
        if(config.lang == 'it'){
            platforms = ["PC, tablet e dispositivi mobili", "Cellulare e tablet", "PC, cellulari e tablet"]
        }
        return platforms[index]
    }
    translateCategory(cat) {
        let cats = ["HTML5", "ANDROID", "VIDEO"]
        let index = cats.indexOf(cat)
        if(config.lang == 'cy'){
            cats = ["ХТМЛ5", "АНДРОИД", "ВИДЕОС"]
        }
        return cats[index]
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    getGameDetail(gameId, uid) {
        let allGames = this.props.game.games;
        let foundGame = allGames.find(game => {
            return (game.gameId == gameId);
        });
        this.props.getGameDetail(foundGame);
        this.setState({
            game: foundGame,
            gameId: gameId,
            categoryId: (foundGame) ? foundGame.categoryId : 0,
            isFavorite: (foundGame) ? (foundGame.isFavorite ? 1 : 0) : 0,
            liked: (foundGame) ? (foundGame.liked ? 1 : 0) : 0
        });
        this.getSimilarGames((foundGame) ? foundGame.categoryId : 0, uid);
    }

    getSimilarGames(categoryId, uid) {
        let allGames = this.props.game.games;
        let similarGames = allGames.filter(game =>{
            return(game.categoryId == categoryId);
        })
        this.props.getSimilarGames(similarGames);
    }

    _openGame(game, e) {
        e.preventDefault();
        const searchContainer = document.querySelector("#search-container");
        if(searchContainer != null){
            if (searchContainer.classList.contains('search-toggle')) {
                searchContainer.classList.toggle("search-toggle");
            }
        }

        if (e.target.classList.contains('isFavorite')) {

            let pEl= ReactDOM.findDOMNode(this.refs['star'+game.gameId]);
            let _check = !pEl.checked;

            let data = {
                uid: this.props.access.uid,
                gameId: game.gameId,
                isFavorite: _check
            };
            if(data.isFavorite){
                this.props.showMessage({
                    message: msg.addToFavorites,
                    type: true
                });
            }
            else{
                this.props.showMessage({
                    message: msg.removeFromFavorites,
                    type: false
                });
            }
            sendData(game.gameTitle, game.categoryName, game.gameType, data.isFavorite ? 'favorite-added' : 'favorite-removed');
            axios.post(vars.BASE_URL+'/favorite', data)
                .then((response) => {
                    if(response.status){
                        pEl.checked = _check;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        } else {
            window.scrollTo(0, 0);
            this.props.history.push(appendUid('/detail/' + game.gameId, this.props.access.uid));
        }


    }
    loadGame(){
        if(this.shouldUpsell(this.state.game.gameId)) this.applyUpsellingFlow();
        else{
            sendData(this.state.game.gameTitle, this.state.game.categoryName, this.state.game.gameType, 'played');
            this.props.show();
            this.setState({
                openGame: !this.state.openGame
            });
            setTimeout(() => {
                this.props.hide();
            }, 1000);
        }   
    }

    shouldUpsell(gameId){
        if(config.subDomain == 'hua') return true;
        if(config.subDomain == 'idsale' || config.subDomain==='gmn'){
            if (gameId == 4 || gameId == 159) return false; //swing robber
            // if (gameId == 31) return false;
            else return true;
        }
        else return false;
    }

    isAppAllowed(gameId){
        if(this.props.access.subscriptionData.allowedApps.indexOf(gameId) == -1) return false;
        else return true;
    }

    applyUpsellingFlow(){
        let paymentPageUrl = '';
        if (config.subDomain == 'hua' || config.subDomain == 'gmn') paymentPageUrl = `http://m.game-lords.com/my/best-games-hua?device=smart&offer=1&game_id=${this.state.game.gameId}&game_name=${this.state.game.gameTitle}&game_image=${this.state.game.gameImage}&msisdn=${this.props.access.subscriptionData.msisdn}`;
        
        else paymentPageUrl = `http://m.game-lords.com/id/seasonal-sale-hua?device=smart&offer=1&game_id=${this.state.game.gameId}&game_name=${this.state.game.gameTitle}&game_image=${this.state.game.gameImage}&msisdn=${this.props.access.subscriptionData.msisdn}`; 
        window.open(paymentPageUrl);
    }
        
    render() {
        this.changeDomain();
        const gameDetail = this.state.game;
        let gameType = gameDetail.gameType;
        if (isGamiclub && config.subDomain === 'fr' && gameDetail.categoryId === 4) {
            gameDetail.categoryName = "Action (18+)";
        }
        const bgImages = ["", "rpg", "augmented-reality", "virtual-reality", "action", "adventure", "arcade", "racing", "sports", "utilities", "action", "adventure", "arcade", "racing", "sports", "rts", "", "premium", "premium", "", "premium", "premium"];
        const gamesParams = {
            direction: 'horizontal',
            slidesPerView: 'auto',
            speed: 500
        }
        const { open } = this.state;

        var starWrapClass = 'game-detail-star-wrap';
        var gameCategoryTitleClass = "game-category-title";
        var gameRelatedMoreClass = "game-related-more";
        if(kazakhDomain){
            starWrapClass += ' kz-star-wrap';
            gameCategoryTitleClass+= ' kz-text';
            gameRelatedMoreClass += ' kz-related-more';
        }
        return (
            <section className="game-detail">
                <div className="container-fluid">
                    {(!this.state.openGame)?
                        <Row className="clearfix">
                            <Col xs="12" className="mb-4 px-0">
                                <TabContent activeTab={this.state.activeTab}>
                                    {(gameDetail != null)?
                                        <TabPane tabId="1">
                                            <Row className={"game-bg-image "+ bgImages[gameDetail.categoryId]}>
                                                <Col lg="3" xs="12" className="text-right top-z-index game-thumb-wrap">
                                                    <img className="img-fluid game-thumb" src={gameDetail.gameImage.includes('https://cdn.game-lords.com/games/http') ? gameDetail.gameImage.split('https://cdn.game-lords.com/games/')[1] : gameDetail.gameImage} alt={gameDetail.gameTitle} />
                                                </Col>
                                                <Col lg="9" xs="12" className="top-z-index game-top-wrap">
                                                    <div className="game-detail-top">
                                                        <div className="game-title-rating">
                                                            {config.subDomain != 'es' && <h3 className="game-detail-title">
                                                                <FormattedMessage id={`${gameDetail.gameTitle.toUpperCase()}`}
                                                                defaultMessage={gameDetail.gameTitle}/></h3>} 
                                                            <StarRatingComponent name="rate1" starCount={5} value={gameDetail.userRating} editing={false} renderStarIcon={() => <i style = {isGamiclub ? {color: 'green'} : isGameflares ? {color:'#FF394B'} : isGamiway ? {color:'#b347a0'} : null} className="fa fa-star custom-star"></i>} />
                                                            {(lang!=='ar' && lang!='kk' && lang!='sv' && lang!='tr') ? <span className="game-user-rating">{gameDetail.userRating}/5 
                                                            <FormattedMessage id="averageRatingBasedOn"
                                                                            defaultMessage=' average user rating based on '
                                                                        />
                                                                         {gameDetail.totalUserReview}
                                                                         <FormattedMessage id="averageRatingReview"
                                                                            defaultMessage=' review'
                                                                        />
                                                            
                                                            </span>:null}
                                                        </div>
                                                        
                                                    </div>
                                                    <div id="contentMob">
                                                            {(gameDetail.gameType.toLowerCase() === 'html5' || gameDetail.gameType.toLowerCase() === 'video') ? <a className="game-btn text-shadow-small" onClick={this.loadGame}>
                                                                <FormattedMessage id="playNow"
                                                                    defaultMessage="Play Now"
                                                                />
                                                            </a> : <a className="game-btn text-shadow-small" href="#" onClick = { e => this.downloadGameApk( e, appendUid(gameDetail.gameFile, this.props.access.uid) ) }>
                                                                <FormattedMessage id="downloadNow"
                                                                    defaultMessage="Download Now"
                                                                />
                                                                
                                                            </a> }
                                                    </div>
                                                    <div className="game-description">
                                                    
                                                        <div className="game-desc-list">
                                                            {(lang !== 'ar' && lang != 'kk' && lang != 'sv' && lang != 'tr' ) ? 
                                                            <ul className="list-unstyled">
                                                                <li><span className="game-desc-left">
                                                                    <FormattedMessage id="category"
                                                                        defaultMessage="Category"
                                                                    />
                                                                </span>
                                                                <span className="game-desc-right" style={{paddingLeft:'40px'}}>:&emsp;<FormattedMessage id={`${gameDetail.categoryName}`} defaultMessage={gameDetail.categoryName}/></span></li>
                                                                <li><span className="game-desc-left">
                                                                    <FormattedMessage id="platform"
                                                                        defaultMessage="Platform"
                                                                    />
                                                                    </span>
                                                                    <span className="game-desc-right" style={{paddingLeft:'40px'}}>:&emsp;{this.translatePlatform(gameDetail.platforms)}</span>
                                                                </li>
                                                                <li><span className="game-desc-left">
                                                                        <FormattedMessage id="type"
                                                                            defaultMessage="Type"
                                                                        />
                                                                    </span>
                                                                    <span className="game-desc-right" style={{paddingLeft:'40px'}}>:&emsp;{this.translateCategory(gameDetail.gameType)}</span></li>
                                                                {/* {lang!=='no' && config.subDomain!='es' && config.subDomain!='idsale'?
                                                                <li><span className="game-desc-left">
                                                                    <FormattedMessage id="description"
                                                                        defaultMessage="Description"
                                                                        />
                                                                    </span><span className="game-desc-right">{gameDetail.gameDesc}</span></li>:null} */}
                                                            </ul>:
                                                        null
                                                    }
                                                        </div>
                                                        <div className="game-detail-links">
                                                            {window.location.hostname.includes('vplay') ? null : 
                                                            <div className="game-detail-star">
                                                                <div className="game-detail-star-wrap">
                                                                    <div className="custom-rating">
                                                                        <input id={'fav'+this.state.gameId} ref={'star'+this.state.gameId} type="checkbox" checked={this.state.isFavorite} onChange={this.markFavourite.bind(this, {game: this.state.game, isFavorite: !this.state.isFavorite})}/>
                                                                        <label htmlFor={'fav'+this.state.gameId}>
                                                                            <i style = {isGamiclub ? {color: 'green'} : isGameflares ? {color:'#FF394B'} : isGamiway ? {color:'#b347a0'} : null} className="fa fa-star-o custom-star isFavorite"></i>
                                                                        </label>
                                                                    </div>
                                                                    <span className="star-name">
                                                                        <FormattedMessage id="favorite"
                                                                            defaultMessage="Favorite"
                                                                        />
                                                                    </span>
                                                                </div>
                                                                <div className={starWrapClass}>
                                                                    <div className="custom-rating">
                                                                        <input id="game-two" type="checkbox" checked={this.state.liked} onChange={this.rateGame.bind(this)}/>
                                                                        <label htmlFor="game-two">
                                                                            <i style = {isGamiclub ? {color: 'green'}: isGameflares ? {color:'#FF394B'} : isGamiway ? {color:'#b347a0'}: null} className="fa fa-thumbs-o-up custom-thumb"></i>
                                                                        </label>
                                                                    </div>
                                                                    <span className="star-name">
                                                                        <FormattedMessage id="rate"
                                                                            defaultMessage="Rate"
                                                                        />
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            }
                                                            <div id="contentDes">
                                                            {(gameDetail.gameType.toLowerCase() === 'html5' || gameDetail.gameType.toLowerCase() === 'video') ? <a className="game-btn text-shadow-small" onClick={this.loadGame}>
                                                                <FormattedMessage id="playNow"
                                                                    defaultMessage="Play Now"
                                                                />
                                                            </a> : <a className="game-btn text-shadow-small" href="#" onClick = { e => this.downloadGameApk( e, appendUid(gameDetail.gameFile, this.props.access.uid) ) }>
                                                                <FormattedMessage id="downloadNow"
                                                                    defaultMessage="Download Now"
                                                                />
                                                                
                                                            </a> }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </TabPane>
                                        : <TabPane tabId="1"><p className="no-game-text">Game not found!</p></TabPane>
                                    }
                                </TabContent>
                            </Col>
                        </Row>
                    :
                   <div style={{objectFit:'cover'}}>
                    {gameDetail.gameType.toLowerCase() === 'video'?
                    <Video autoPlay style={{height: window.innerWidth < 576 ? '100%' : '65vh'}} src={gameDetail.gameFile}
                        controls={['PlayPause', 'Seek', 'Time', 'Volume', 'Fullscreen']}>
                    </Video>
                        :<object data={gameDetail.gameFile} className="openGame"></object> }
                         <h3 style={{padding:'20px 0px'}}>
                             <FormattedMessage id={`${gameDetail.gameTitle.toUpperCase()}`}
                                defaultMessage={gameDetail.gameTitle}/>
                        </h3>   
                    </div>}
                    <Col xs="12" className="game-related-container">
                                <div className="game-related-top">
                                    <div className="game-category" style={isGamiclub ? {borderBottom: '1px solid green'} : isGameflares ? {borderBottom: '1px solid #FF394B'} : isGamiway ? {borderBottom: '1px solid #b347a0'}:  null}>
                                        {gameType == 'VIDEO' 
                                        ? <h2 style={isGamiclub ? {color: 'white', backgroundColor: 'green'} : isGameflares ? {color: 'white', backgroundColor: '#FF394B'}  : isGamiway ? {color: 'white', backgroundColor: '#b347a0'}: null} className={gameCategoryTitleClass}>
                                            <FormattedMessage id="relatedVideo"
                                                defaultMessage="Related Videos"
                                            />
                                        </h2> 
                                        : <h2 style={isGamiclub ? {color: 'white', backgroundColor: 'green'} : isGameflares ? {color: 'white', backgroundColor: '#FF394B'} :isGamiway ? {color: 'white', backgroundColor: '#b347a0'} : null} className={gameCategoryTitleClass}>
                                            <FormattedMessage id="relatedGames"
                                                defaultMessage="Related Games"
                                            />
                                        </h2>} 
                                        <a className={gameRelatedMoreClass} style={isGamiclub ? {color: 'green'} : isGameflares ? {color:'#FF394B'}  : isGamiway ? {color:'#b347a0'}: null} href={"/#/category/"+this.state.categoryId + "?uid=" + this.props.access.uid}>
                                            <FormattedMessage id="viewAll"
                                                defaultMessage="View All"
                                            />
                                        </a>
                                    </div>
                                </div>
                                <div className="medium-desktop-tabs similar-tabs">
                                    {(this.props.game.similarGames.length > 1) ?
                                        <Swiper {...gamesParams} shouldSwiperUpdate={true}>
                                            { this.props.game.similarGames.map((game) => {
                                                if(game.gameId != this.state.gameId) {          
                                                    return (
                                                        <div className="swiper-game-card" key={game.gameId}>
                                                            <Card className={isGamiclub ? "game-card-gamiclub" : isGameflares ? "game-card gameflares-game-card": isGamiway ? "game-card gamiway-card": "game-card"} onClick={this._openGame.bind(this, game)}>
                                                                <div className="game-card-inner">
                                                                    <div className="game-thumb-wrap">
                                                                        <CardImg className="game-thumb" top width="100%" src={game.gameImage.includes('https://cdn.game-lords.com/games/http') ? game.gameImage.split('https://cdn.game-lords.com/games/')[1] : game.gameImage} alt={game.gameTitle} />
                                                                    </div>
                                                                    <div className="game-card-details">
                                                                        {config.subDomain != 'es' && <CardTitle className="game-title text-shadow">
                                                                        <FormattedMessage id={`${game.gameTitle.toUpperCase()}`}
                                                                            defaultMessage={game.gameTitle}/>
                                                                        </CardTitle>}
                                                                        {window.location.hostname.includes('vplay') ? null : 
                                                                        <div className="custom-rating isFavorite">
                                                                            <input id={'fav'+game.gameId} ref={'star'+game.gameId} className="isFavorite" type="checkbox" checked={game.isFavorite}/>
                                                                            <label htmlFor={'fav'+game.gameId} className="isFavorite">
                                                                                <i style = {isGamiclub ? {color: 'green'} : isGameflares ? {color:'#FF394B'} : isGamiway ? {color:'#b347a0'} : null} className="fa fa-star-o custom-star isFavorite"></i>
                                                                            </label>
                                                                        </div>
                                                                        }
                                                                        <div className="game-card-left large-width">
                                                                            {(gameDetail.gameType.toLowerCase() === 'html5' || gameDetail.gameType.toLowerCase() === 'video') ? <a className="game-btn text-shadow-small small-font" onClick={this._openGame.bind(this, game)}>
                                                                                <FormattedMessage id="playNow"
                                                                                    defaultMessage="Play Now"
                                                                                />
                                                                            </a> : <a className="game-btn text-shadow-small small-font" href="#" onClick={this._openGame.bind(this,game)}>
                                                                                    <FormattedMessage id="downloadNow"
                                                                                        defaultMessage="Download Now"
                                                                                    />

                                                                                </a>}
                                                                            {/* <StarRatingComponent name="rate1" starCount={5} value={game.userRating} editing={false} renderStarIcon={() => <i className="fa fa-star custom-star"></i>} /> */}
                                                                        </div>
                                                                        {/* <div className="game-card-right text-uppercase text-shadow text-right">{(game.gameType.toLowerCase() === 'html5')? <i className="fa fa-html5" aria-hidden="true"></i> : <i className="fa fa-android" aria-hidden="true"></i>}</div> */}
                                                                    </div>
                                                                </div>
                                                            </Card>
                                                        </div>
                                                    )
                                                }
                                            })}
                                        </Swiper>
                                        : <p className="white-text-color no-game-text"><FormattedMessage id="no related games found" defaultMessage="No related games found." /></p>
                                    }
                                </div>
                            </Col>
                </div>
                <Modal open={open} onClose={this.onCloseModal.bind(this)} center>
                  <h5 className="modelHeading">Incompatible Device</h5>
                  <p>
                    Device is not compatible with the file
                  </p>
                      <a className="modelAnchor"  href={appendUid("/#/home/html", this.props.access.uid)}>
                          <button className="modelButton">Okay</button>
                      </a>
                </Modal>
            </section>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        game: state.GamesReducer,
        access: state.WelcomeReducer,
        header: state.HeaderReducer,
        search: state.SearchReducer,

    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        getGameDetail,
        getSimilarGames,
        showMessage
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(GameDetail);



// WEBPACK FOOTER //
// ./src/components/GameDetail/GameDetail.js